// @generated by liquid-inject from src/snippets/algolia-product-view.ts
// src/sections/algolia-main-search/constants.ts
var CDN_SEARCH_INSIGHTS = "https://cdn.jsdelivr.net/npm/search-insights@2.17.3/dist/search-insights.min.js";
var SRI_SEARCH_INSIGHTS = "sha384-puGTibgj5tll4rKBSZMNWXFBG+MuObLcSQE3VnZ/PbPozbHGK7qhg0CFKG9FBUjZ";

// src/sections/algolia-main-search/load-script.ts
var pending = /* @__PURE__ */ new Map();
function loadScript(src, integrity) {
  const cached = pending.get(src);
  if (cached) return cached;
  const promise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.crossOrigin = "anonymous";
    if (integrity) script.integrity = integrity;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
  pending.set(src, promise);
  return promise;
}

// src/sections/algolia-main-search/insights.ts
var ALGOLIA_USER_TOKEN_KEY = "diptyque:algolia:user-token";
var PIXEL_CONFIG_KEY = "algolia_config";
var ONE_TRUST_ANALYTICS_PATTERN = /perform|analyt|statis|mesure|audience/i;
var ONE_TRUST_ANALYTICS_GROUP_IDS = ["PERF", "C0002"];
var CONSENT_POLL_INTERVAL_MS = 250;
var CONSENT_POLL_ATTEMPTS = 60;
var initPromise = null;
var initKey = "";
var trackingAllowed = false;
var cachedUserToken = null;
var customerPrivacyPromise = null;
function loadCustomerPrivacy() {
  if (customerPrivacyPromise) return customerPrivacyPromise;
  customerPrivacyPromise = new Promise((resolve) => {
    const shopify = window.Shopify;
    if (shopify?.customerPrivacy) {
      resolve();
      return;
    }
    if (typeof shopify?.loadFeatures !== "function") {
      resolve();
      return;
    }
    const done = () => resolve();
    window.setTimeout(done, 3e3);
    try {
      shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        done
      );
    } catch {
      done();
    }
  });
  return customerPrivacyPromise;
}
function shopifyAnalyticsAllowed() {
  const customerPrivacy = window.Shopify?.customerPrivacy;
  if (typeof customerPrivacy?.analyticsProcessingAllowed !== "function") {
    return null;
  }
  try {
    return customerPrivacy.analyticsProcessingAllowed() === true;
  } catch {
    return null;
  }
}
function oneTrustConsentFromCookie() {
  const match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]*)/);
  if (!match) return null;
  const groups = new URLSearchParams(match[1]).get("groups");
  if (!groups) return null;
  const granted = groups.split(",").map((pair) => pair.split(":")).filter(([, value]) => value?.trim() === "1").map(([id]) => id?.trim());
  return granted.some((id) => id && ONE_TRUST_ANALYTICS_GROUP_IDS.includes(id));
}
function oneTrustAnalyticsAllowedFromSdk() {
  const consentWindow = window;
  const active = consentWindow.OnetrustActiveGroups;
  if (typeof active !== "string" || !active) return null;
  const activeIds = active.split(",").map((id) => id.trim()).filter(Boolean);
  let groups = [];
  try {
    groups = consentWindow.OneTrust?.GetDomainData?.().Groups ?? [];
  } catch {
    groups = [];
  }
  const analyticsIds = groups.filter(
    (group) => ONE_TRUST_ANALYTICS_PATTERN.test(
      `${group.GroupName ?? ""} ${group.Type ?? ""}`
    )
  ).map((group) => group.CustomGroupId).filter((id) => Boolean(id));
  const ids = analyticsIds.length ? analyticsIds : ONE_TRUST_ANALYTICS_GROUP_IDS;
  return ids.some((id) => activeIds.includes(id)) ? true : null;
}
function oneTrustAnalyticsAllowed() {
  const cookie = oneTrustConsentFromCookie();
  const live = oneTrustAnalyticsAllowedFromSdk();
  if (cookie === true || live === true) return true;
  if (cookie === false || live === false) return false;
  return null;
}
async function resolveTrackingConsent() {
  await loadCustomerPrivacy();
  return shopifyAnalyticsAllowed() === true || oneTrustAnalyticsAllowed() === true;
}
var trackingEnabledCallbacks = [];
function onAlgoliaTrackingEnabled(callback) {
  if (trackingAllowed) {
    callback();
    return;
  }
  trackingEnabledCallbacks.push(callback);
}
function flushTrackingEnabledCallbacks() {
  const callbacks = trackingEnabledCallbacks.splice(0);
  callbacks.forEach((callback) => callback());
}
var consentWatcherStarted = false;
function watchConsentChanges(appId, apiKey, indexName) {
  if (consentWatcherStarted) return;
  consentWatcherStarted = true;
  const reinit = () => {
    if (trackingAllowed) return;
    initPromise = null;
    initKey = "";
    void initAlgoliaInsights(appId, apiKey, indexName);
  };
  document.addEventListener("visitorConsentCollected", reinit);
  window.addEventListener("OneTrustGroupsUpdated", reinit);
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (trackingAllowed || attempts > CONSENT_POLL_ATTEMPTS) {
      window.clearInterval(timer);
      return;
    }
    if (oneTrustAnalyticsAllowed() === true || shopifyAnalyticsAllowed() === true) {
      window.clearInterval(timer);
      reinit();
    }
  }, CONSENT_POLL_INTERVAL_MS);
}
function createToken() {
  if ("crypto" in window && "randomUUID" in window.crypto) {
    return window.crypto.randomUUID();
  }
  return `anonymous-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
function getAlgoliaUserToken() {
  if (!trackingAllowed) {
    cachedUserToken ?? (cachedUserToken = createToken());
    return cachedUserToken;
  }
  try {
    const storedToken = window.localStorage.getItem(ALGOLIA_USER_TOKEN_KEY);
    if (storedToken) {
      cachedUserToken = storedToken;
      return storedToken;
    }
    const nextToken = cachedUserToken ?? createToken();
    window.localStorage.setItem(ALGOLIA_USER_TOKEN_KEY, nextToken);
    cachedUserToken = nextToken;
    return nextToken;
  } catch {
    cachedUserToken ?? (cachedUserToken = createToken());
    return cachedUserToken;
  }
}
function installInsightsQueue() {
  const insightsWindow = window;
  if (typeof insightsWindow.aa === "function") return insightsWindow.aa;
  const queued = [];
  const aa = ((...args) => {
    queued.push(args);
  });
  aa.queue = queued;
  insightsWindow.AlgoliaAnalyticsObject = "aa";
  insightsWindow.aa = aa;
  return aa;
}
async function initAlgoliaInsights(appId, apiKey, indexName) {
  const key = `${appId}:${apiKey}`;
  if (initPromise && initKey === key) return initPromise;
  initKey = key;
  initPromise = (async () => {
    trackingAllowed = await resolveTrackingConsent();
    if (!trackingAllowed) {
      watchConsentChanges(appId, apiKey, indexName);
      return null;
    }
    const aa = installInsightsQueue();
    const userToken = getAlgoliaUserToken();
    aa("init", { appId, apiKey, userToken, useCookie: false });
    writePixelConfig({ appId, apiKey, indexName, userToken });
    try {
      await loadScript(CDN_SEARCH_INSIGHTS, SRI_SEARCH_INSIGHTS);
    } catch (error) {
      console.warn("Algolia Insights could not be loaded", error);
      return null;
    }
    flushTrackingEnabledCallbacks();
    return aa;
  })();
  return initPromise;
}
function sendAlgoliaEvent(method, payload) {
  if (!trackingAllowed) return false;
  const aa = window.aa;
  if (!aa || !payload.index || payload.objectIDs.length === 0) return false;
  aa(method, payload);
  return true;
}
function writePixelConfig({
  appId,
  apiKey,
  indexName,
  userToken
}) {
  if (!trackingAllowed || !indexName) return;
  try {
    window.localStorage.setItem(
      PIXEL_CONFIG_KEY,
      JSON.stringify({
        app_id: appId,
        search_api_key: apiKey,
        index_name: indexName,
        user_token: userToken
      })
    );
  } catch {
    return;
  }
}
function sendAlgoliaViewEvent(index, objectID) {
  return sendAlgoliaEvent("viewedObjectIDs", {
    eventName: "Product Viewed",
    index,
    objectIDs: [objectID]
  });
}

// src/snippets/algolia-product-view.ts
var AlgoliaProductView = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.sentObjectIDs = /* @__PURE__ */ new Set();
    this.popStateHandler = null;
  }
  async connectedCallback() {
    const {
      algoliaAppId: appId,
      algoliaApiKey: apiKey,
      algoliaIndexName: index,
      algoliaObjectId: objectID
    } = this.dataset;
    if (!appId || !apiKey || !index || !objectID) return;
    await initAlgoliaInsights(appId, apiKey, index);
    this.sendView(index, objectID);
    this.watchVariantChanges(index);
    onAlgoliaTrackingEnabled(() => {
      const variantId = new URLSearchParams(window.location.search).get("variant") || objectID;
      this.sendView(index, variantId);
    });
  }
  disconnectedCallback() {
    if (!this.popStateHandler) return;
    window.removeEventListener("popstate", this.popStateHandler);
    this.popStateHandler = null;
  }
  sendView(index, objectID) {
    if (this.sentObjectIDs.has(objectID)) return;
    if (sendAlgoliaViewEvent(index, objectID)) this.sentObjectIDs.add(objectID);
  }
  watchVariantChanges(index) {
    const readVariantId = () => new URLSearchParams(window.location.search).get("variant");
    const onVariantChange = () => {
      const variantId = readVariantId();
      if (variantId) this.sendView(index, variantId);
    };
    this.popStateHandler = onVariantChange;
    window.addEventListener("popstate", onVariantChange);
  }
};
if (!window.customElements.get("c-algolia-product-view")) {
  window.customElements.define("c-algolia-product-view", AlgoliaProductView);
}
